export default "__VITE_ASSET__CMcajCA0__"